import { CustomerInfo } from '../customer-info';
import { SharedDataService } from '../shared/shared-data/shared-data.service';
import { RestAPIService } from '../shared/shared-service/restAPI.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  details: any;
  customerInfo: CustomerInfo;
  validationMessages: any;
  portalConfigValuesFromS3: any;
  @BlockUI() blockUI: NgBlockUI;
  constructor(private sharedDataService: SharedDataService, private restAPIService: RestAPIService,
    private router: Router) {
    this.details = {
      firmName: '',
      userId: ''
    }
    this.blockUI.stop();
  }
  ngOnInit() {
    if (window.location.hostname !== undefined && window.location.hostname !== null && window.location.hostname !== "") {
      let backUrl = "https://".concat(window.location.hostname).concat("/welcome");
      console.log("backUrl: " + backUrl);
      window.localStorage.setItem("backURL", backUrl);
    }

    this.getCustomerInfo();
  }

  getCustomerInfo(): void {
    this.restAPIService.getCustomerInfo().then(customerInfo => {
      this.customerInfo = customerInfo;
      this.details.firmName = this.customerInfo.firmName;
      this.details.userId = this.customerInfo.userId;
      this.sharedDataService.saveCustomerInfo(this.customerInfo);
      this.restAPIService.getPortalConfigValuesFromS3(
        JSON.stringify({ 'firmId': this.customerInfo.firmId, 'portalName': this.customerInfo.portal })
      ).then(portalConfigValuesFromS3 => {
        this.portalConfigValuesFromS3 = portalConfigValuesFromS3;
        this.sharedDataService.savePortalConfigValuesFromS3(portalConfigValuesFromS3);
      }).catch(error => {
        this.sharedDataService.showError(error.message);
      });


      this.restAPIService.getValidationMessages().then(validationMessages => {
        this.validationMessages = validationMessages;
        this.sharedDataService.saveValidationMessages(validationMessages);
        this.router.navigate(['/layout/dashboard']);
      }).catch(error => {
        this.sharedDataService.showError(error.message);
      });

    }).catch(error => {
      this.sharedDataService.showError(error.message);
    });
  }
}


